<template>
  <form class="email-confirm-form">
    <div class="text-center mb-6">
      <v-chip color="primary" variant="tonal" size="large" class="mb-4">
        {{ state.email }}
      </v-chip>
      <div class="mb-4">
        <v-otp-input v-model="state.code" length="6" variant="outlined"></v-otp-input>
      </div>
    </div>

    <v-btn
      block
      size="large"
      color="primary"
      variant="elevated"
      @click="onClickConfirm"
      :loading="state.loadingConfirm"
      :disabled="state.code.length !== 6"
      class="mb-3"
    >
      Verify Email
    </v-btn>

    <v-btn
      block
      size="large"
      color="secondary"
      variant="outlined"
      @click="onClickResendConfirmEmail"
      :loading="state.loadingResend"
      class="mb-4"
    >
      Resend Code
    </v-btn>

    <v-divider class="my-4"></v-divider>

    <div class="text-center">
      <RouterLink :to="URLs.PAGE_AUTH_LOGIN" class="text-decoration-none text-primary">
        Back to Login
      </RouterLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { URLs } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { makeAlert } from "@/utils";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

const authStore = useAuthStore();

const state = ref({
  email: route.query.email as string,
  code: "",
  loadingConfirm: false,
  loadingResend: false
});

const onClickConfirm = async () => {
  if (state.value.code.length !== 6) {
    makeAlert("Code must be 6 characters.", "error");
    return;
  }
  state.value.loadingConfirm = true;
  const response = await authStore.confirmEmail({
    email: state.value.email,
    code: state.value.code
  });
  if (response.status) {
    makeAlert("Confirmed successfully. Now you can login.", "success");
    router.push({
      name: "login"
    });
  } else {
    makeAlert(response.message, "error");
  }
  state.value.loadingConfirm = false;
};

const onClickResendConfirmEmail = async () => {
  state.value.loadingResend = true;
  const response = await authStore.resendConfirmEmail({
    email: state.value.email
  });
  if (response.status) {
    makeAlert("Resend confirm email successfully.", "success");
  } else {
    makeAlert(response.message, "error");
  }
  state.value.loadingResend = false;
};
</script>
